var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.216 12.75h-6.2a9.98 9.98 0 002.921 6.346 9.244 9.244 0 003.28-6.346zM6.09 20.083a10.737 10.737 0 003.63-7.333h1.53v9.235a9.96 9.96 0 01-5.16-1.902zm3.63-8.833a10.737 10.737 0 00-3.63-7.333 9.96 9.96 0 015.16-1.902v9.235H9.72zM4.938 4.904a9.244 9.244 0 013.28 6.346H2.014a9.98 9.98 0 012.922-6.346zm17.047 7.846a9.97 9.97 0 01-2.409 5.797 8.497 8.497 0 01-3.039-5.797h5.448zm-3.476 6.859a9.991 9.991 0 01-3.477-6.859h-2.28v9.235a9.969 9.969 0 005.757-2.376zm1.067-14.156a8.497 8.497 0 00-3.039 5.797h5.448a9.97 9.97 0 00-2.409-5.797zM12.75 11.25h2.281a9.991 9.991 0 013.477-6.859 9.969 9.969 0 00-5.758-2.376v9.235z",
    fill: "currentColor"
  })));
}
SvgSportFilled.displayName = 'SportFilled';
export default SvgSportFilled;